import axios, {AxiosError} from "axios";
import {get, isString} from "lodash";
import {useCallback, useEffect} from "react";
import {toast} from "sonner";
import {useAuth} from "~/auth/useAuth";
import {consumerUrls} from "~/routes/consumerUrls";
import {axiosConsumerAppInstance} from "./ConsumerApiManager";
import {useAmplitude} from "~/contexts";
import {useNavigate} from "react-router-dom";

const ConsumerApiExceptionManager = () => {
  const navigate = useNavigate();
  const {setError} = useAmplitude();
  const {clearCredentials, loggedIn} = useAuth();
  const logoutHandler = useCallback((): void => {
    clearCredentials();
    window.location.reload();
  }, [clearCredentials]);

  const notificationHandler = useCallback((error: any) => {
    const errorData = get(error, "response.data");
    if (errorData === "Already has an active payment plan") {
      navigate(consumerUrls.accounts.url);
    }
    const errorMessage = errorData && isString(errorData) ? errorData : undefined;
    setError(errorMessage);
    toast.error(errorMessage || "Network connection is lost.");
  }, []);

  const errorHandler = useCallback(
    (error: AxiosError) => {
      if (!axios.isAxiosError(error)) {
        logoutHandler();
        return Promise.reject(error);
      }

      const errorStatus = error.response?.status;

      if ((errorStatus === 401 || errorStatus === 403) && loggedIn) {
        logoutHandler();
        return Promise.reject(error);
      }

      const isCancel = axios.isCancel(error);
      if (isCancel) {
        return Promise.reject(error);
      }

      notificationHandler(error);
      return Promise.reject(error);
    },
    [logoutHandler, notificationHandler]
  );

  useEffect(() => {
    axiosConsumerAppInstance.interceptors.response.use(undefined, (error) => errorHandler(error));
  }, []);

  return null;
};

export {ConsumerApiExceptionManager};
